var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.75C9.57843 21.75 10.25 21.0784 10.25 20.25C10.25 19.4216 9.57843 18.75 8.75 18.75C7.92157 18.75 7.25 19.4216 7.25 20.25C7.25 21.0784 7.92157 21.75 8.75 21.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.75C19.3284 21.75 20 21.0784 20 20.25C20 19.4216 19.3284 18.75 18.5 18.75C17.6716 18.75 17 19.4216 17 20.25C17 21.0784 17.6716 21.75 18.5 21.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21562 6.75H22.0344L19.5594 15.4125C19.4711 15.7269 19.282 16.0036 19.0211 16.2C18.7603 16.3965 18.4422 16.5019 18.1156 16.5H9.13437C8.80783 16.5019 8.4897 16.3965 8.22886 16.2C7.96803 16.0036 7.77893 15.7269 7.69062 15.4125L4.29688 3.54375C4.25203 3.38696 4.1573 3.24905 4.02704 3.15093C3.89677 3.05282 3.73808 2.99983 3.575 3H2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.fb3a2216b1be3573a4df226aaf828594.svg";
export { ForwardRef as ReactComponent };